import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import {
  ShoppingProvider,
  useShoppingContext,
} from "./context/ShoppingContext";
import PrivateRoute from "./PrivateRoute";
import Landing from "./Landing/Landing";
import SignInForm from "./Landing/User/SignIn/SignInForm";
import SignUpForm from "./Landing/User/SignUp/SignUpForm";
import Galpones from "./Granja/Galpones";
import Granja from "./MisGranjas/Granja";
import Header from "./Header/Header";
import Footer from "./Footer/Footer"; // Importa el nuevo Footer
import "./styles.css";
import Aves from "./Granja/Aves/Aves";
import EditAve from "./Granja/Edit/EditAve/EditAve";
import EditGalpon from "./Granja/Edit/EditGalpon/EditGalpon";
import EditAlimento from "./Granja/Edit/EditAlimento/EditAlimento";
import MisGranjas from "./MisGranjas/MisGranjas";
import EditGranja from "./Granja/Edit/EditGranja/EditGranja";
import GranjaMap from "./MisGranjas/GranjaMap/GranjaMap";
import MisAlimentos from "./MisAlimentos/MisAlimentos";
import Buscar from "./Buscar/Buscar";
import TiposHuevo from "./TiposHuevo/TiposHuevo";
import Produccion from "./MisGranjas/GranjaMap/ProduccionHuevos/Produccion";
import Configuracion from "./Configuracion/Configuracion";

function App() {
  const location = useLocation();
  const { loading } = useShoppingContext();

  const shouldShowFooter =
    location.pathname !== "/" && location.pathname !== "/login"; // Muestra el Header y Footer condicionalmente
  const { isDarkMode } = useShoppingContext();
  if (loading) {
    return <div className="loading-container">Cargando...</div>;
  }

  return (
    <div className={"app"}>
      {<Header />}

      <Routes>
        <Route path="/" element={<Landing />} />

        <Route
          path="/create"
          element={
            <div
              className={
                isDarkMode ? "content-container" : "content-container light"
              }
            >
              <SignUpForm />
            </div>
          }
        />
        <Route
          path="/login"
          element={
            <div
              className={
                isDarkMode ? "content-container" : "content-container light"
              }
            >
              <div className="content">
                <SignInForm />
              </div>
            </div>
          }
        />

        <Route
          path="/mis-granjas"
          element={
            <PrivateRoute>
              <MisGranjas />
            </PrivateRoute>
          }
        />

        <Route
          path="/buscar"
          element={
            <PrivateRoute>
              <Buscar />
            </PrivateRoute>
          }
        />

        <Route
          path="/mis-alimentos"
          element={
            <PrivateRoute>
              <MisAlimentos />
            </PrivateRoute>
          }
        />

        <Route
          path="/tipos-de-huevo"
          element={
            <PrivateRoute>
              <TiposHuevo />
            </PrivateRoute>
          }
        />
        <Route
          path="/mis-granjas/:id"
          element={
            <PrivateRoute>
              <Granja />
            </PrivateRoute>
          }
        />

        <Route
          path="/edit-granja/:id"
          element={
            <PrivateRoute>
              <EditGranja />
            </PrivateRoute>
          }
        />

        <Route
          path="/mis-granjas/:id/all-tables"
          element={
            <PrivateRoute>
              <div className="header-margin">
                <GranjaMap />
              </div>
            </PrivateRoute>
          }
        />
        <Route
          path="/edit-ave/:id"
          element={
            <PrivateRoute>
              <div className="header-margin">
                <EditAve />
              </div>
            </PrivateRoute>
          }
        />
        <Route
          path="/edit-galpon/:id"
          element={
            <PrivateRoute>
              <div className="header-margin">
                <EditGalpon />
              </div>
            </PrivateRoute>
          }
        />

        <Route
          path="/edit-alimento/:id"
          element={
            <PrivateRoute>
              <div className="header-margin">
                <EditAlimento />
              </div>
            </PrivateRoute>
          }
        />

        <Route
          path="/mis-galpones"
          element={
            <PrivateRoute>
              <Galpones />
            </PrivateRoute>
          }
        />
        <Route
          path="/mis-aves"
          element={
            <PrivateRoute>
              <Aves />
            </PrivateRoute>
          }
        />
        <Route
          path="/granjas/:id/produccion-huevos"
          element={
            <PrivateRoute>
              <Produccion />
            </PrivateRoute>
          }
        />
        <Route
          path="/configuracion"
          element={
            <PrivateRoute>
              <Configuracion />
            </PrivateRoute>
          }
        />
      </Routes>
      {shouldShowFooter && <Footer />}
    </div>
  );
}

function MainApp() {
  return (
    <Router>
      <AuthProvider>
        <ShoppingProvider>
          <App />
        </ShoppingProvider>
      </AuthProvider>
    </Router>
  );
}

export default MainApp;
